<template>
    <div
        class="l-ss-c-categories-dropdown"
        :class="{
            'l-ss-c-categories-dropdown-is-opened': isVisible,
            'l-ss-c-categories-dropdown-is-closed': !isVisible,
            'l-ss-c-categories-dropdown-is-selected': localCategoryId,
        }">
        <div class="l-ss-c-categories-dropdown-select">
            <div
                class="l-ss-c-categories-dropdown-label"
                v-show="!$screen.isMobile || ($screen.isMobile && !isVisible)"
                :class="{
                    'l-ss-c-categories-dropdown-label-is-selected': localCategoryId,
                    'l-ss-c-categories-dropdown-label-is-opened': isVisible,
                }"
                @click="toggleList">
                <template v-if="isVisible">
                    <span class="l-ss-c-categories-dropdown-label-text">{{ activeCategoryLabel || $t('categories.categories') }}</span>
                </template>
                <template v-else>
                    <span class="l-ss-c-categories-dropdown-label-text">{{ activeCategoryLabel }}&nbsp;</span>
                    <i
                        class="l-ss-c-icon l-ss-c-categories-dropdown-label-icon"
                        v-html="iconArrowDown"></i>
                </template>
            </div>
            <div
                v-if="isVisible"
                class="l-ss-c-categories-dropdown-body">
                <div class="l-ss-c-categories-dropdown-body-inner">
                    <p v-if="isLoading">{{ $t('categories.pleaseWait') }}</p>
                    <template v-else>
                        <i
                            v-if="$screen.isMobile"
                            class="l-ss-c-categories-dropdown-icon l-ss-c-categories-dropdown-icon-close-popup"
                            @click="toggleList"
                            v-html="iconClosePopup"></i>
                        <ul class="l-ss-c-categories-dropdown-list l-ss-c-categories-dropdown-list-root">
                            <li
                                class="l-ss-c-categories-dropdown-list-item"
                                :class="{
                                    'l-ss-c-categories-dropdown-list-item-is-selected': isSelected(option),
                                    'l-ss-c-categories-dropdown-list-item-is-active': isActive(option)
                                }"
                                v-for="option in rootOptions"
                                :key="`category-selector-${option.value || option.key}`"
                                @mouseenter="() => onEnterCategory(option)"
                                @click="(event) => onCategorySelect(event, option, option.value === '')">
                                {{ option.label }}
                            </li>
                        </ul>
                        <div
                            class="l-ss-c-categories-dropdown-body-viewer"
                            v-show="(otherOptions || []).length > 0">
                            <ul
                                class="l-ss-c-categories-dropdown-list l-ss-c-categories-dropdown-list-secondary"
                                v-for="option in otherOptions"
                                :key="`category-selector-${option.subCatTitle.value || option.subCatTitle.key}`">
                                <li>
                                    <a
                                        class="l-ss-c-categories-dropdown-list-item l-ss-c-categories-dropdown-list-item-is-title"
                                        :class="{
                                            'l-ss-c-categories-dropdown-list-item-is-selected': isSelected(option.subCatTitle),
                                            'l-ss-c-categories-dropdown-list-item-is-active': isActive(option.subCatTitle)
                                        }"
                                        :href="makeCategoryUrl(option.subCatTitle)"
                                        @click="(event) => onCategorySelect(event, option.subCatTitle, option.subCatTitle.value !== '')">
                                        {{ option.subCatTitle.label }}
                                    </a>
                                </li>
                                <li
                                    v-for="body in option.subCatBody"
                                    :key="body.id">
                                    <a
                                        class="l-ss-c-categories-dropdown-list-item"
                                        :href="makeCategoryUrl(body)"
                                        @click="(event) => onCategorySelect(event, body, body.value !== '')">
                                        {{ body.label }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import iconArrowDown from '../assets/images/icons/arrow-down.svg';
    import iconClosePopup from '../assets/images/icons/close-popup.svg';

    export default {
        props: {
            isLoading: {
                type: Boolean,
                default: true,
            },
            hasQuery: {
                type: Boolean,
                default: false,
            },
            hasFilters: {
                type: Boolean,
                default: false,
            },
            selectedCategoryId: {
                type: [Number, String],
                required: true,
            },
            categories: {
                type: Array,
                required: true,
            },
            available: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                localCategoryId: null,
            };
        },
        computed: {
            isVisible() {
                return this.$root.props.store.state.ui.isCategoriesListVisible;
            },
            iconClosePopup() {
                return iconClosePopup;
            },
            iconArrowDown() {
                return iconArrowDown;
            },
            localSelectedCategory() {
                const id = this.localCategoryId ? this.localCategoryId : null;
                return id ? (this.categories || []).find(category => category.id === id) : null;
            },
            rootCategories() {
                return (this.categories || []).filter(category => (!category.level || category.level === 0) && category.id !== '0');
            },
            otherCategories() {
                const categories = (this.categories || []);
                let list = categories.filter(category => category.level && category.level === 1);
                let thirdLevelCategories = categories.filter(category => category.level && category.level === 2);
                let selectedId = this.localCategoryId;
                selectedId = selectedId ? selectedId : null;
                let thirdLevelCategoriesList = [];
                if (selectedId) {
                    const selectedCategory = (this.categories || []).find(category => category.id === selectedId);
                    /*
                     * Parent.lft < Child.lft AND Parent.rgt > Child.rgt
                     * get all child
                     */
                    if (!selectedCategory) {
                        return [];
                    }
                    list = list.filter(category => selectedCategory.lft < category.lft && selectedCategory.rgt > category.rgt);
                    let intervalCategories = [];
                    list.forEach((item) => {
                        intervalCategories = thirdLevelCategories.filter(category => item.lft < category.lft && item.rgt > category.rgt);
                        thirdLevelCategoriesList.push({ subCatTitle: item, subCatBody: intervalCategories });
                    });
                }
                return thirdLevelCategoriesList;
            },
            rootOptions() {
                return [
                    {
                        value: '',
                        key: 'all',
                        label: this.$t('categories.isNoCategory').trim(),
                        count: undefined,
                    },
                    ...this.rootCategories.map(({ id, title, hits }) => (
                        {
                            value: `${id}`.trim(),
                            key: `id_${id}`,
                            label: `${title}`.trim(),
                            count: hits,
                        }),
                    ),
                ];
            },
            otherOptions() {
                // Don't display subcategories for "All categories"
                if (this.$screen.isMobile === false && !this.localCategoryId) {
                    return [];
                }
                // Parent category
                const mobileActions = [];
                if (this.$screen.isMobile) {
                    mobileActions.push({
                        subCatTitle: {
                            value: '',
                            key: 'back',
                            label: `${this.$t('categories.backCategory').trim()}`,
                        },
                    });
                    if (this.localSelectedCategory) {
                        mobileActions.push({
                            subCatTitle: {
                                value: this.localSelectedCategory.id,
                                key: 'test',
                                label: `${this.$t('categories.selectCategory')} ${this.localSelectedCategory.title}`,
                            },
                        });
                    }
                }
                const mapCategory = (category) => {
                    return {
                        value: `${category.id}`.trim(),
                        label: `${category.title}`.trim(),
                        count: category.hits,
                    };
                };
                return [
                    ...mobileActions,
                    ...this.otherCategories
                        .map(({ subCatTitle, subCatBody }) => {
                            return Object.assign(
                                {
                                    subCatTitle: {
                                        ...mapCategory(subCatTitle),
                                    },
                                },
                                {
                                    subCatBody: (subCatBody || []).map((item) => ({
                                        ...mapCategory(item),
                                    })),
                                },
                            );
                        })
                        .sort((left, right) => {
                            if (left.subCatBody.length < right.subCatBody.length) {
                                return 1;
                            }
                            if (left.subCatBody.length > right.subCatBody.length) {
                                return -1;
                            }
                            return 0;
                        }),
                ];
            },
            activeCategoryLabel() {
                if (this.selectedCategoryId) {
                    const id = this.selectedCategoryId;
                    const active = (this.categories || []).find(category => category.id === id);

                    return active ? active.title || id : id;
                }
                return this.$t('categories.isNoCategory');
            },
        },
        watch: {
            categories: {
                handler(list) {
                    if (this.selectedCategoryId && this.localCategoryId === null && list && list.length) {
                        const selectedCategory = list.find(category => category.id === this.selectedCategoryId);
                        if (selectedCategory) {
                            this.localCategoryId = selectedCategory.parentId;
                        }
                    }
                },
                immediate: true,
                deep: true,
            },
        },
        methods: {
            toggleList() {
                if (this.isVisible) {
                    this.$nextTick(() => {
                        this.localCategoryId = this.selectedCategoryId;
                    });
                }
                this.$emit('toggle');
            },
            onEnterCategory(option) {
                if (this.$screen.isMobile === false) {
                    this.localCategoryId = option.value ? option.value : null;
                }
            },
            isSelected(option) {
                if (!option.value && !this.selectedCategoryId) {
                    return true;
                }
                return this.selectedCategoryId === option.value;
            },
            isActive(option) {
                if (!option.value) {
                    return Boolean(this.selectedCategoryId) === false;
                }
                return option.value === this.localCategoryId;
            },
            makeCategoryUrl(option) {
                return `#/search/categoryId=${option.value}&skip=0`;
            },
            emitCategory(categoryId, showList) {
                this.$emit('toggle', showList);
                this.$nextTick(() => {
                    this.$emit('change', { categoryId, skip: 0 });
                });
            },
            onCategorySelect(event, option, emit) {
                event.preventDefault();
                event.stopPropagation();
                const hasSubCategories = (this.categories || []).some(category => {
                    return category.parentId === option.value;
                });
                if (this.$screen.isMobile && hasSubCategories && Boolean(emit) === false || option.key === 'back') {
                    this.localCategoryId = option.value;
                } else {
                    this.emitCategory(option.value, false);
                }
            },
            onEmptyResetClick() {
                if (this.selectedCategoryId) {
                    this.emitCategory('', true);
                } else {
                    if (this.hasFilters) {
                        this.$emit('reset-filters');
                    } else {
                        this.$emit('reset-query');
                    }
                }
            },
        },
    };
</script>